// Enums
export const Auth = {
  AdminId: "admin-id",
  AccessToken: "access-token",
  RefreshToken: "refresh-token"
}

function isLocalCookieRuntime() {
  const env = process.env.NODE_ENV

  if (env === "production") return false
  if (env === "local") return true
  if (typeof window === "undefined" || !window.location) return false

  return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)
}

function getCookieEnv() {
  if (isLocalCookieRuntime()) return "local"

  return process.env.NODE_ENV || "development"
}

function withEnv(key) {
  const env = getCookieEnv()

  const isNonProd = env !== "production"
  const isSelectedKey = key === Auth.AccessToken || key === Auth.RefreshToken

  return isNonProd && isSelectedKey ? `${env}~${key}` : key
}

function getCookieConfig() {
  return isLocalCookieRuntime()
    ? ""
    : " domain=.scasset.com; secure; samesite=strict;"
}

export function setCookie(key, value) {
  const config = getCookieConfig()
  const cookieKey = withEnv(key)

  document.cookie = `${cookieKey}=${value}; path=/;${config}`
}

export const getCookie = (key) => {
  const cookieKey = withEnv(key)
  const cookie = document.cookie.match(
    new RegExp(`(^|;)\\s*${cookieKey}=([^;]*)`)
  )

  return cookie ? cookie[2] : null
}

export const unsetCookie = (key) => {
  const config = getCookieConfig()
  const cookieKey = withEnv(key)

  // Remove Cookie env
  document.cookie = `${cookieKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${config}`
};

/**
 * Set axios authorization
 * @returns {AxiosRequestHeaders}
 */
export function accessHeaders() {
  return {
    'Authorization': `Bearer ${getCookie(Auth.AccessToken)}`
  }
}
